'use client';

import { DealershipAttrs } from '@core/Entities/Dealership/Dealership.entity';
import { Locale } from '@core/Entities/Locale/Locale.entity';

import { Button } from '@gds/Button/Button';
import { Email } from '@gds/Icons/Paths/Email';
import { Typography } from '@gds/Typography/Typography';
import { useIsExperimentEnabled } from '@growthBookExperimentation/Hooks/useIsExperimetEnabled';

import { LocationAttrs } from 'Components/SearchWidget/Search.entity';

import { PlpFiltersMessagesProps } from '../Filters/FilterPanel.entity';

import { useSavedSearchForm } from './UseSavedSearchForm';

import styles from './SavedSearchForm.module.css';
interface SavedSearchPageCtaProps {
  locale: Locale;
  strings: PlpFiltersMessagesProps;
  locationAttrs?: LocationAttrs;
  dealerAttrs?: DealershipAttrs;
}

export const SavedSearchPageCta = ({
  locale,
  strings,
  locationAttrs,
  dealerAttrs,
}: SavedSearchPageCtaProps) => {
  const { openForm, canUseSavedSearch } = useSavedSearchForm({
    locale,
    strings,
    locationAttrs,
    dealerAttrs,
  });
  const isButtonPrimary = useIsExperimentEnabled('saved-search-cta-visibility', '1');

  if (!canUseSavedSearch) return null;

  return (
    <div className={styles.pageCtaWrapper}>
      <Typography Component={'h2'} variant={'h4'}>
        {strings.cantFind}
      </Typography>
      <Typography variant={'subheading4'}>{strings.createPersonalisedAlert}</Typography>
      <Button
        leftIcon={<Email />}
        {...(isButtonPrimary && { color: 'primary' })}
        {...(!isButtonPrimary && { variant: 'outlined' })}
        onClick={openForm}
      >
        {strings.createAlert}
      </Button>
    </div>
  );
};

SavedSearchPageCta.displayName = 'SavedSearchPageCta';
